import React from "react";
import { useTranslation } from "react-i18next";
import { RELATION_GROUP_IDS, type RelationGroupId } from "utilities";

import RelationGroupChip from "./RelationGroupChip";
import type { RelationGroupChipsProps } from "./relationGroupChips.types";

import styles from "./RelationGroupChips.module.css";

/**
 * Picks which context of relations the canvas draws — Family, Allegiance, Places and so on, with
 * "All" for the everything-at-once view the canvas has always shown.
 *
 * Single-select by design: the point is to read one kind of story at a time. Only edges are
 * filtered, never nodes, so switching contexts never moves anything on the canvas.
 */
export const RelationGroupChips = ({ onChange, value }: RelationGroupChipsProps) => {
	const { t } = useTranslation("homePage");

	return (
		<div aria-label={t("view.relationGroupsLabel")} className={styles.chipRow} role="group">
			{RELATION_GROUP_IDS.map((group: RelationGroupId) => (
				<RelationGroupChip
					key={group}
					group={group}
					isSelected={group === value}
					label={t(`view.relationGroups.${group}`)}
					onSelect={onChange}
				/>
			))}
		</div>
	);
};
